export default __webpack_public_path__ + "static/media/tinnauerL.6b34cdd0.jpg";